import { Row, Col, Table, Modal } from 'antd';
import { WordCloud, Treemap, Radar } from '@ant-design/charts';
import { SentenceRaw } from './App'
export default function ChartView(props) {
  const layout = {
    xl: 24, xxl: 12,
  }
  const keywordConfig = {
    data: props.keywords.words,
    wordField: 'word',
    weightField: 'weight',
    colorField: 'word',
    spiral: 'rectangular',
    padding: 0,
    wordStyle: {
      fontFamily: 'Verdana',
      fontSize: [12, 92],
      rotation: 0,
      padding: 0,
    },
    random() {
      return 0.5;
    },
  };
  const classConfig = {
    data: props.classes.map(([label, prob]) => ({ label, prob })).sort((a, b) => b.prob - a.prob),
    xField: 'label',
    yField: 'prob',
  };
  const entities = new Map()
  props.entities.words
    .filter(({ type }) => ['person', 'organization', 'location'].includes(type))
    .forEach(({ word, type, weight }) => {
      if (!entities.has(type)) {
        entities.set(type, {
          name: type,
          children: []
        })
      }
      entities.get(type).children.push({
        type,
        name: word,
        value: weight,
      })
    })
  return <Row justify='space-between'>
    <Col span={24}>
      <h3>重点句子</h3>
      <SentenceRaw sentences={props.sentences.flat().sort((a, b) => b.weight - a.weight).slice(0, 3)} />
    </Col>
    <Col {...layout}>
      <h3>关键词</h3>
      <WordCloud {...keywordConfig} />
    </Col>
    <Col {...layout}>
      <h3>实体</h3>
      <Treemap
        data={{
          name: 'root',
          children: Array.from(entities.values())
        }}
        colorField='type'
        color={({ type }) => global.colorMap[type] || 'black'}
      // onReady={plot => plot.on('element:click', (...args) => console.log(...args))}
      />
    </Col>
    <Col {...layout}>
      <h3>分类</h3>
      <Radar {...classConfig} />
    </Col>
    <Col {...layout}>
      <h3>XLink</h3>
      <Table dataSource={props.xlink.words} columns={[
        {
          title: '标签',
          dataIndex: 'word',
          key: 'label',
        },
        {
          title: 'XLore链接',
          dataIndex: 'info',
          key: 'url',
          render: info => <a href={info.url} target="_blank" rel="noreferrer">{info.url}</a>,
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
        },
      ]} onRow={record => {
        return {
          onClick: event => Modal.info({
            maskClosable: true,
            title: record.word,
            content: <span dangerouslySetInnerHTML={{ __html: record.info.abstract }} />
          })
        };
      }} pagination={{
        defaultPageSize: 8,
        pageSizeOptions: [8, 16, 32, 64, 128]
      }} scroll={{ y: 400 }} />
    </Col>
  </Row>;
}